import React from "react";
import { GET_RATE_TABLE, INSERT_RATE_TABLE, UPDATE_RATE_TABLE, DELETE_RATE_TABLE } from "../../api-setup/api-endpoints";
import { getUserCredential } from "../../lib/cookies";
import { POSTAPI, errStatusHandler, generateHeader } from "../../api-setup/api-helper";
import { GridColumnDataMapper } from "../../utils/utils";
import { useHistory } from "react-router";
import { useDispatch } from "react-redux";
import { setNewMessage } from "../../redux/actions/setting-actions";
import { GetPeriodTypeAPI, GetPeriodsDataList, GetUnitType } from "../../lib/common-service";

export default function RateTables() {
  /**
   * start to define default states for common grid functions (list/insert/update/delete)
   */
  const cookiesData = getUserCredential();
  const header = {
    "x-access-token": cookiesData.secretToken,
  };
  const history = useHistory();
  const dispatch = useDispatch();
  const [data, setData] = React.useState([]);
  const [columns, setColumns] = React.useState([]);
  const [dataCount, setDataCount] = React.useState(0);
  const [loadingState, setLoadState] = React.useState({
    isSaveData: undefined,
    isDeleteData: undefined,
  });
  const [initialLoading, setLoadingState] = React.useState(false);
  const [editData, setEditData] = React.useState("");
  const [confirmationPopup, setConfirmationPopup] = React.useState({
    title: "Delete",
    desc: "Are you sure you want to delete this record?",
    isVisible: false,
    type: "",
    actionBtn: [],
    data: {},
    action: "Delete",
  });
  const [originalData, setOriginalData] = React.useState([]);
  const [isAPICalling, setAPICallingState] = React.useState(false);
  const [isRefreshLoading, setRefreshLoading] = React.useState(false);
  /**
   * end to define default states for common grid functions (list/insert/update/delete)
   */

  /**
   * start to define default states for period type, period, unit type
   */
  const [periodsTypeFields, setPeriodTypeFields] = React.useState({
    periodTypeValue: {
      in_period_mstr_key: "",
      in_period_start_date: "",
      in_period_end_date: "",
    },
    periodTypeData: [],
    isPeriodTypeDataLoading: true,
  });
  const [originPeriodType, setOriginPeriodType] = React.useState([]);

  const [periodsFields, setPeriodFields] = React.useState({
    periodsValue: {
      id: "",
      text: "",
    },
    periodsData: [],
    isPeriodDataLoading: true,
  });
  const [originPeriod, setOriginPeriod] = React.useState([]);
  const [unitTypeDataSource, setUnitTypeDataSource] = React.useState([]);
  const [originalColumns, setOriginalColumns] = React.useState([]);

  /**
   * end to define default states for period type, period, unit type
   */

  const getPeriodTypesData = async () => {
    let periodTypeData = {
      in_filter: "AND a.period_type_hierarchy_level IS NOT NULL",
      in_sort_number: null,
      in_sort_order: null,
    };

    let res = await GetPeriodTypeAPI(periodTypeData, dispatch, history);

    if (res.length > 0) {
      let tempArray = [];

      res.map((item) => {
        let obj = {};
        obj.text = item.period_type_name;
        obj.id = item.period_type_mstr_key;

        tempArray.push(obj);
        return 0;
      });

      setOriginPeriodType(tempArray);

      //get period data from period type
      getPeriodsData(tempArray[0].id);

      setPeriodTypeFields({
        ...periodsTypeFields,
        periodTypeData: tempArray,
        periodTypeValue: tempArray[0],
        isPeriodTypeDataLoading: false,
      });
    } else {
      setPeriodTypeFields({
        ...periodsTypeFields,
        isPeriodTypeDataLoading: false,
      });
    }
  };

  const getPeriodsData = async (id) => {
    setPeriodFields({
      ...periodsFields,
      isPeriodDataLoading: true,
    });

    let periodsDataReq = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: `AND a.period_type_mstr_key = ${id}`,
      in_sort_number: null,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 100,
      in_sort_number_concat: "a.period_end_date DESC, a.period_level_order DESC",
    };

    let resPeriods = await GetPeriodsDataList(periodsDataReq, dispatch, history);

    if (resPeriods.length > 0) {
      let tempArray = [];

      resPeriods.map((item) => {
        let obj = {};

        obj.text = item.period_name;
        obj.id = item.period_mstr_key;
        obj.in_period_start_date = item.period_start_date;
        obj.in_period_end_date = item.period_end_date;

        tempArray.push(obj);

        return 0;
      });

      setOriginPeriod(tempArray);

      setPeriodFields({
        ...periodsFields,
        periodsData: tempArray,
        periodsValue: tempArray[0],
        isPeriodDataLoading: false,
      });
    } else {
      setPeriodFields({
        periodsValue: { id: "", text: "" },
        periodsData: [],
        isPeriodDataLoading: false,
      });
    }
  };

  const getUnitTypeData = async () => {
    let unitTypeDataReq = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter: " AND (a.system_unit_name NOT LIKE 'fdm_%')",
      in_sort_number: 3,
      in_sort_order: null,
      in_page_row_offset: 0,
      in_page_rows: 9999,
    };

    let resUnitType = await GetUnitType(unitTypeDataReq, dispatch, history);

    if (resUnitType.length > 0) {
      let tempArray = [];

      resUnitType.map((item) => {
        let obj = {};

        obj.text = item.system_unit_name;
        obj.id = item.system_unit_mstr_key;

        tempArray.push(obj);

        return 0;
      });

      setUnitTypeDataSource(tempArray);
    }
  };

  const getListDataAsync = (listData, extraColumn) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_RATE_TABLE, null, header, listData, dispatch).then((res) => {
        if (res) {
          if (res.data.out_parameters.out_ret_code > 0) {
            setLoadingState(true);
            errStatusHandler(res, history, dispatch);
          }
          setAPICallingState(false);
          setLoadingState(true);
          setEditData("");
          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          let userData = JSON.parse(JSON.stringify(res.data.row_result));

          if (listData.in_load_type === "grid-reload") {
            const columData = GridColumnDataMapper(res.data.out_parameters.out_column_xml);

            columData.map((cItem, idx) => {
              cItem.minWidth = 210;
              cItem.show =
                cItem.field === "rate_table_mstr_key" ||
                cItem.field === "version" ||
                cItem.field === "rate_table_unittype_name"
                  ? false
                  : true;
              cItem.selected = false;
              cItem.rowId = idx;
              return 0;
            });
            setOriginalColumns(columData);
            setColumns(columData);
          }
          userData.map((item, idx) => {
            item.rowId = idx;
            item.selected = false;
            item.expanded = false;
            return 0;
          });
          setData(userData);
          setOriginalData([...userData]);
          setDataCount(res.data.out_parameters.out_total_rows);
          setRefreshLoading(false);
          resolve(userData);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const addDataAsync = (bodyData) => {
    setLoadState({ ...loadingState, isSaveData: false });
    POSTAPI(false, INSERT_RATE_TABLE, null, header, bodyData, dispatch).then((res) => {
      if (res.status) {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        } else {
          setLoadState({ ...loadingState, isSaveData: true });
        }
      }
    });
    setLoadState({ ...loadingState, isSaveData: false });
  };

  const deleteDataAsync = async (bodyData) => {
    setRefreshLoading(true);
    return new Promise(function (resolve, reject) {
      POSTAPI(false, DELETE_RATE_TABLE, null, header, bodyData, dispatch).then((res) => {
        setRefreshLoading(false);
        if (res.data.out_parameters.out_ret_code > 0) {
          let msg = res.data.out_parameters.out_error_msg;

          setLoadState({ ...loadingState, isDeleteData: false });
          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          dispatch(
            setNewMessage({
              message: msg,
              type: "Error",
              show: true,
            })
          );
        } else {
          setConfirmationPopup({
            ...confirmationPopup,
            isVisible: false,
            type: "",
            actionBtn: [],
            data: {},
            action: "",
          });
          setLoadState({ ...loadingState, isDeleteData: true });
          setTimeout(function () {
            resolve("success");
          });
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const updateDataAsync = (bodyData, customTableData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, UPDATE_RATE_TABLE, null, generateHeader(), bodyData, dispatch).then((res) => {
        if (res && res.data.out_parameters.out_ret_code === 0) {
          resolve(true);
        } else {
          dispatch(
            setNewMessage({
              message: res?.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  const exportDataAsync = (bodyData) => {
    return new Promise(function (resolve, reject) {
      POSTAPI(false, GET_RATE_TABLE, null, generateHeader(), bodyData, dispatch).then((res) => {
        if (res && (res.data.out_parameters.out_ret_code === 0 || res.data.out_parameters.out_ret_code === 2)) {
          resolve(res.data.row_result);
        } else {
          dispatch(
            setNewMessage({
              message: res?.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          resolve([]);
          errStatusHandler(res, history, dispatch);
        }
      });
    })
      .then((res) => {
        return res;
      })
      .catch((res) => {
        if (res.data.out_parameters.out_ret_code > 0) {
          dispatch(
            setNewMessage({
              message: res.data.out_parameters.out_error_msg,
              type: "Error",
              show: true,
            })
          );
          errStatusHandler(res, history, dispatch);
        }
      });
  };

  return [
    {
      data,
      columns,
      dataCount,
      setData,
      setColumns,
      editData,
      originalData,
      isAPICalling,
      setEditData,
      confirmationPopup,
      setConfirmationPopup,
      initialLoading,
      setAPICallingState,
      loadingState,
      setLoadState,
      setOriginalData,
      setRefreshLoading,
      isRefreshLoading,
      originPeriodType,
      periodsTypeFields,
      setPeriodTypeFields,
      originPeriod,
      periodsFields,
      setPeriodFields,
      unitTypeDataSource,
      originalColumns,
    },
    {
      getListDataAsync,
      addDataAsync,
      deleteDataAsync,
      updateDataAsync,
      getPeriodTypesData,
      getPeriodsData,
      getUnitTypeData,
      exportDataAsync,
    },
  ];
}
